export default __webpack_public_path__ + "static/media/trade_hk_01.98ca1ae5.png";